import styled from 'styled-components';
import {BLACK} from '../../globalVariables/GlobalVariables';
import {dFlexCenter, justifyStart} from '../../globalVariables/GlobalFlex';
import {getFontWeight, getSpacing, getToken} from '@tickchak/react-share/app';

export const title = styled.div`
    color: ${BLACK};
    font-size: 22px;
    font-weight: 800;
    white-space: pre-line;
`;
export const text = styled.div`
    color: ${BLACK};
    white-space: pre-line;
    margin-block: 20px;
    line-height: 1.3;
`;
export const contact = styled.div`
    color: ${BLACK};
    font-weight: 500;
    white-space: pre-line;
    line-height: 1.3;
`;

export const checkboxRow = styled.div`
    ${dFlexCenter}
    ${justifyStart}
    margin: ${getSpacing('spaceMd')} 0;
    gap: ${getSpacing('spaceSm')};
    color: ${getToken('color.text.default')};
    font-weight: ${getFontWeight('bold')};
    line-height: 1.3;
    & > label{
        background-color: var(--primitive-white);
        border: 1px solid var(--color-border-default);
        margin: 0;
    }
`;
